<template>
  <oie-portal-wrapper
    v-if="showDesktopFilter || mq('to-small')"
    breakpoint="small"
    name="filters"
    :class="['filters', {'element--is-loading element--is-loading--at-top': state.fetchingFilters}]"
    tabindex="0">
    <div v-if="state.filtersInitialized" class="filters__content">
      <!-- CLEAR FILETSR -->
      <oie-base-action
        v-if="hasSelectedFilters"
        class="filters__clear"
        theme="destructive"
        size="medium"
        @click="clearFilters">
        <template #iconPrepend>
          <oie-base-icon icon="close" size="xs"></oie-base-icon>
        </template>
        {{ tStatic('clearFilters') }}
      </oie-base-action>

      <!-- CATEGORIES -->
      <template v-if="hasCategories">
        <h2 id="filter-category-selector-title" class="h2-semi-bold">
          {{ tStatic('categories') }}
        </h2>
        <oie-filter-category-selector></oie-filter-category-selector>

        <oie-base-divider></oie-base-divider>
      </template>

      <!-- VEHICLES AND OTHER FILTERS -->
      <template v-if="hasVehicles || hasFacets">
        <h2 class="h2-semi-bold">
          {{ tStatic('filters') }}
        </h2>

        <oie-filter-vehicle-selector v-if="hasVehicles"></oie-filter-vehicle-selector>

        <oie-filter-facet-selector v-if="hasFacets && hasSelectableFacets"></oie-filter-facet-selector>
      </template>
    </div>
  </oie-portal-wrapper>
</template>

<script>
import { state, hasSelectedFilters, clearFilters, hasCategories, hasVehicles, hasSelectableFacets, hasFacets } from '@/store/filters'
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      state
    }
  },
  computed: {
    ...mapGetters('ui', ['showDesktopFilter']),
    hasSelectedFilters() {
      return hasSelectedFilters()
    },
    hasCategories() { return hasCategories() },
    hasVehicles() { return hasVehicles() },
    hasSelectableFacets() { return hasSelectableFacets() },
    hasFacets() { return hasFacets() }
  },

  methods: {
    ...mapActions('ui', ['toggleValue', 'setActiveSlideIn']),
    clearFilters() {
      clearFilters()
    }
  }
}
</script>

<style lang="scss">
.filters {
  position: relative;
  padding: measure(quarter);
  border: 1px solid color(gray-4);
  flex: 0 0 18rem;
  width: 18rem;
  background-color: color(white);
  min-height: 7rem;
}

.filters--disabled {
  opacity: 0.5;
  pointer-events: none;
}

.filters__content {
  display: flex;
  flex-direction: column;
  gap: measure(half);
}

.filters__header {
  margin-bottom: measure(half);
}

.filters__clear {
  align-self: flex-start;
}

</style>
